import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { UserDataProvider } from './auth/UserData';
import { FeatureFlagProvider } from './context/FeatureFlagContext';
import "./i18n"; 
import { LicenseInfo } from '@mui/x-license-pro';

// MUI X Pro license
LicenseInfo.setLicenseKey('3f8a500f6e13b0783ee8ba2989bdb89cTz0xMjI4NzUsRT0xNzk2Njg3OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

// Public routes are served from prerendered snapshots
// (scripts/prerender-marketing.js). The capture is a whole-document dump,
// and React only takes over #root — anything the captured render left
// elsewhere (MUI modal portals beside #root, `overflow: hidden` on <body>,
// aria-hidden on #root) would otherwise survive hydration and lock the page.
// The script sanitises its output, but keep the client defensive too.
(function scrubPrerenderResidue() {
  const rootEl = document.getElementById('root');
  for (const el of Array.from(document.body.children)) {
    if (el === rootEl || el.tagName === 'SCRIPT' || el.tagName === 'NOSCRIPT') continue;
    el.remove();
  }
  document.body.removeAttribute('style');
  document.documentElement.removeAttribute('style');
  if (rootEl) rootEl.removeAttribute('aria-hidden');
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
  <ThemeProvider>
    <UserDataProvider>
      <FeatureFlagProvider>
        <App />
      </FeatureFlagProvider>
    </UserDataProvider>
    </ThemeProvider>
    </BrowserRouter>
  
);

// Register service worker for PWA + push notifications
serviceWorkerRegistration.register();

reportWebVitals();
